import { render, staticRenderFns } from "./TenderForm.vue?vue&type=template&id=6b40e790"
import script from "./TenderForm.vue?vue&type=script&lang=js"
export * from "./TenderForm.vue?vue&type=script&lang=js"
import style0 from "./TenderForm.vue?vue&type=style&index=0&id=6b40e790&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports